import { ALL } from '../../constants'
import { IResultsByType, IallResultsLimits } from '../../types'
import { IState } from './types'

/**
 * This fn adds the "All" section to the resultsByType object
 */
const addAllSection = (resultsByType: any, allResultsOrder: string[], allResultsLimits: IallResultsLimits) => {
  let allResults: any[] = []

  allResultsOrder.forEach((type) => {
    const results = resultsByType[type] || []
    const limit = allResultsLimits[type] || results.length
    if (results) {
      allResults = [...allResults, ...results.slice(0, limit)]
    }
  })

  resultsByType[ALL] = allResults
}

/**
 * This fn converts the results array into an object with the type as the key
 */
const getResultsByType = (results: any[]) => {
  return results.reduce<IResultsByType>((acc: any, result: any) => {
    acc[result.label] = result.results.map((item: any) => {
      return {
        ...item,
        id: `awesomebar-result-${result.label.replace(/\s/g, '-')}-${item.label.replace(/\s/g, '-')}`,
      }
    })
    return acc
  }, {})
}

/**
 * This fn is called when the user types in the search input
 * It loops through the configs and calls the search fn for each config
 * It returns a promise that resolves with the resultsByType object
 */
export const onSearch = async (searchTerm: string, state: IState) => {
  const { configs, allResultsOrder, allResultsLimits } = state
  const searchPromises = configs.map((config) => {
    if (!searchTerm) {
      return Promise.resolve({
        label: config.label,
        results: [],
      })
    }
    return config.search(searchTerm).then((results = []) => {
      return {
        label: config.label,
        results,
      }
    })
  })

  const results = await Promise.all(searchPromises)
  const resultsByType: IResultsByType = getResultsByType(results)
  addAllSection(resultsByType, allResultsOrder, allResultsLimits)
  return resultsByType
}
